<div class="quiz">
  @if (isLoading() && questions().length === 0) {
    <div class="quiz__loading">{{ 'app.components.quiz.loading' | translate }}</div>
  } @else if (error()) {
    <div class="quiz__error">{{ error() }}</div>
  } @else if (questions().length === 0) {
    <div class="quiz__empty">{{ 'app.components.quiz.empty' | translate }}</div>
  } @else {
    <div class="quiz__content">
      @if (description()) {
        <div class="quiz__description">{{ description() }}</div>
      }
      <div class="quiz__body">
        <div class="quiz__question-text">
          {{ currentQuestion().wording }}
        </div>
        <div class="quiz__answers">
          @for (answer of currentQuestion().answers; track answer.id; let i = $index) {
            <button
              type="button"
              class="quiz__answer"
              [class.quiz__answer--selected]="isAnswerCorrect(answer)"
              [class.quiz__answer--checked-wrong]="isAnswerChecked(answer) && !isCorrect()"
              [disabled]="!!checkedAnswerId()"
              (click)="selectAnswer(answer); checkAnswer()"
            >
            <span class="quiz__answer-badge">{{ i + 1 }}</span>
            <span class="quiz__answer-text">{{ answer.wording }}</span>
            </button>
          }
        </div>
        @if (lastQuestionWrong()) {
          <div class="quiz__wrong-message">
            {{ 'app.components.quiz.watchVideoAndTryAgain' | translate }}
          </div>
        }
        <div class="quiz__nav">
          <button
            type="button"
            class="quiz__nav-btn quiz__nav-btn--prev"
            [disabled]="!canGoPrev()"
            [attr.aria-label]="'app.components.quiz.prev' | translate"
            (click)="goPrev()"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M11 12L7 9L11 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="quiz__nav-center">
            <span class="quiz__nav-progress">{{ progressText() }}</span>
            <!-- <button type="button" class="quiz__nav-explanation">
              {{ 'app.components.quiz.seeExplanation' | translate }}
            </button> -->
          </div>
          <button
            type="button"
            class="quiz__nav-btn quiz__nav-btn--next"
            [disabled]="!canGoNext()"
            [attr.aria-label]="'app.components.quiz.next' | translate"
            (click)="goNext()"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <path d="M7 6L11 9L7 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
</div>
